import './CountryCoverage.scss';

import { MagnifyingGlass } from '@phosphor-icons/react';
import { CountryFlag, Resource } from '@travelwin/core';
import classNames from 'classnames';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCountryUtils } from '../../hooks/useCountryUtils';
import { prepareCountriesOptions } from '../../utils/countryUtils';

interface CountryCoverageProps {
  countries: Resource[];
  extended: boolean;
  autoFocus: boolean;
}

const className = 'c-CountryCoverage';

const CountryCoverage = ({
  countries,
  extended,
  autoFocus,
}: CountryCoverageProps) => {
  const { t, i18n } = useTranslation();
  const { getCountryNameTranslation } = useCountryUtils();
  const [countryValue, setCountryValue] = useState<string>('');

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCountryValue(event.target.value);
  };

  const preparedCountries = prepareCountriesOptions({
    t,
    lang: i18n.language,
    data: countries,
    inputValue: countryValue,
  });

  const shouldShowSearch = countries.length >= 7;

  const containerClassName = classNames(
    `${className}__country-list-container`,
    extended
      ? `${className}__country-list-container--modal`
      : `${className}__country-list-container--card`,
    shouldShowSearch && `${className}__country-list-container--searchable`,
  );

  return (
    <div
      className={classNames(
        `${className}__list-container`,
        !extended && `${className}__list-container--fixed-size`,
      )}
    >
      {!extended && (
        <div className={`${className}__title-bar-container`}>
          <span className={`${className}__title-bar`}>
            {t('label.countryCoverage', 'Coverage')}
          </span>
        </div>
      )}
      {shouldShowSearch && (
        <div className={`${className}__search-input-container`}>
          <MagnifyingGlass
            size={24}
            weight="bold"
            className={`${className}__search-icon`}
          />
          <input
            id="country"
            className={`${className}__search-input`}
            value={countryValue}
            onChange={handleInputChange}
            autoFocus={autoFocus}
          />
        </div>
      )}

      <div className={containerClassName}>
        <div
          className={`${
            shouldShowSearch
              ? `${className}__country-list`
              : `${className}__country-list-short`
          }`}
        >
          {preparedCountries.map((country) => (
            <div key={country.alias} className={`${className}__country-item`}>
              <CountryFlag countryCode={country.alias.toLowerCase()} />
              <span className={`${className}__country-name`}>
                {getCountryNameTranslation(country.description)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountryCoverage;
